/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { TransitioningDetailsResponse } from './TransitioningDetailsResponse.types.tsx';

export const getTransitioningDetails = (cloudId: string): Promise<TransitioningDetailsResponse> =>
	performGetRequest<TransitioningDetailsResponse>(
		`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`,
	).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getTransitioningDetails',
				packageName: 'jiraRouterResourcesEocUnlockOperations',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});

export const transitioningDetailsResource: RouteResource<TransitioningDetailsResponse> =
	createResource({
		type: 'EOC_UNLOCK_OPERATIONS',
		getKey: () => 'eoc-unlock-operations',
		getData: async (_, { tenantContext: { cloudId } }) => getTransitioningDetails(cloudId),
		maxAge: 0,
		isBrowserOnly: true,
	});
